import { render } from "./ModalWithdrawBtcAccept.vue?vue&type=template&id=34841172&scoped=true&ts=true"
import script from "./ModalWithdrawBtcAccept.vue?vue&type=script&lang=ts"
export * from "./ModalWithdrawBtcAccept.vue?vue&type=script&lang=ts"

import "./ModalWithdrawBtcAccept.vue?vue&type=style&index=0&id=34841172&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34841172"]])

export default __exports__